import "./index.css";

function SubHeader({ title }) {
  return <div className="SubHeader">{title}</div>;
}

export default SubHeader;
